import { SportsHeader } from '../SportsHeader/SportsHeader';
import { getLiveBettingSportName } from 'config/constants';
import { sportTranslationKey } from 'helpers/sportI18n';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useProgressiveCount } from 'hooks/useProgressiveCount';
import { LiveEvent } from '../LiveEvent/LiveEvent';
import { LiveMarket } from '../liveMarkets';
import styles from './LiveEventsList.module.css';

interface Props {
  events: any[];
  sportId?: number;
  favorite?: boolean;
  /** No collapsible sport header (the modern sport rail names the sport). */
  bare?: boolean;
  /** Modern: the odds each row shows (leave out for 1 X 2). */
  market?: LiveMarket;
}

export const LiveEventsList = ({
  events,
  sportId,
  favorite = false,
  bare = false,
  market,
}: Props) => {
  const [expanded, setExpanded] = useState(!!sportId);
  const drawn = useProgressiveCount(events.length);
  const { t } = useTranslation();
  const headerTitle =
    favorite || !sportId
      ? t('my_live_favorites_label')
      : t(sportTranslationKey(sportId), {
          defaultValue: getLiveBettingSportName(sportId),
        });

  if (bare) {
    // With a market picked, only the matches that offer it (owner,
    // 2026-11-01: "next goal, 1st half" ran on into matches past that half,
    // each with a "no offer" line).
    const rows = market?.pick
      ? events.filter((ev) => !!market.pick!(ev)?.odds?.length)
      : events;
    return (
      <div className={styles.eventsWrapper}>
        {rows.length === 0 && events.length > 0 && (
          <p className={styles.noOffer}>{t('no_bet_offer_message')}</p>
        )}
        {rows.slice(0, drawn).map((x) => (
          <LiveEvent
            event={x}
            key={x.fi}
            isFavorite={favorite}
            market={market}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      <div onClick={() => setExpanded(!expanded)}>
        <SportsHeader
          sportId={sportId}
          iconOverrideKey={!sportId ? 'highlights' : undefined}
          title={headerTitle}
          count={events.length}
          expanded={expanded}
        />
      </div>
      {expanded && (
        <div className={styles.eventsWrapper}>
          {events.slice(0, drawn).map((x) => (
            <LiveEvent event={x} key={x.fi} isFavorite={favorite} />
          ))}
        </div>
      )}
    </>
  );
};
